import { ContextMenuHeader, ContextMenuItem, ContextMenuStyle, MenuItemSeparator } from './OdfjellContextMenu.styles';

export interface Position {
    x: number;
    y: number;
}

export interface MenuItem {
    isSeparator?: boolean;
    content: React.ReactNode;
    isDisabled: boolean;
    onClick?: ((event) => Promise<void>) | ((event) => void);
    className?: string;
}

interface ContextMenuProps {
    position: Position;
    menuItems: MenuItem[];
    header?: string;
    className?: string;
    dataContextMenu?: string; // Added data-context-menu attribute prop
}

const OdfjellContextMenu: React.FC<ContextMenuProps> = ({ position, menuItems, header, className = '', dataContextMenu }: ContextMenuProps) => {
    const onItemClick = async (onClick: ((event) => Promise<void>) | ((event) => void), event: any) => {
        const result = onClick(event);
        if (result instanceof Promise) {
            await result;
        }
    };
    return (
        <ContextMenuStyle
            x={position.x}
            y={position.y}
            className={className}
            data-context-menu={dataContextMenu} // Added data-context-menu attribute
            style={{
                position: 'absolute',
                width: '300px',
                background: '#fff',
                boxShadow: '#eee 0 2px 6px 2px',
                border: '1px solid #ccc',
                padding: '6px',
                zIndex: '10',
                cursor: 'pointer',
                left: `${position.x}px`,
                top: `${position.y}px`,
            }}
        >
            {header && <ContextMenuHeader>{header}</ContextMenuHeader>}
            {menuItems.map((item, index) =>
                item.isSeparator ? (
                    <MenuItemSeparator key={index} />
                ) : (
                    <ContextMenuItem
                        key={index}
                        isDisabled={item.isDisabled}
                        onClick={!item.isDisabled && item.onClick ? (event) => onItemClick(item.onClick, event) : undefined}
                        className={item.className}
                    >
                        {item.content}
                    </ContextMenuItem>
                )
            )}
        </ContextMenuStyle>
    );
};

export default OdfjellContextMenu;
